// src/index.ts
import { extendBaseTheme } from "@stepstone-genesis/dresscode-base";
import { milkround as baseMilkroundTheme } from "@stepstone-genesis/design-tokens";
var milkround = extendBaseTheme("milkround", baseMilkroundTheme);
export {
  milkround
};
